import { render, staticRenderFns } from "./TemporaryCountingTable.vue?vue&type=template&id=35310a32"
import script from "./TemporaryCountingTable.vue?vue&type=script&lang=js"
export * from "./TemporaryCountingTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports